/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function () {
    'use strict';

    var checkButton = {
        templateUrl: 'app/components/checkButton/check-button.html',
        controller: checkButtonController,
        controllerAs: 'vm',
        bindings: {
            target: '@',
            label: '@',
            name: '@',
            ngModel: '=',
            onChangeEvent: '&'
        }
    };

    angular
        .module('completeAir')
        .component('checkButton', checkButton);

    checkButtonController.$inject = ['$timeout']

    function checkButtonController($timeout) {
        var vm = this;

        vm.values = [];

        vm.isValid = null;

        vm.addToArray = function (regulation) {
            vm.values.push(regulation);
        }

        vm.deleteFromArray = function (regulation) {
            var index = vm.values.indexOf(regulation);
            if (index > -1) {
                vm.values.splice(index, 1);
            }
        }

        vm.handleCheckBox = function (choice, target, name) {
            $timeout(function () {
                vm.onChangeEvent();
            }, 50);


            if (choice) {
                vm.addToArray(target);
            } else if (!choice) {
                vm.deleteFromArray(target);
            }

            if (vm.values.length > 0) {
                vm.isValid = true;
            }else if(vm.values.length <= 0){
                vm.isValid = false;
            }

        }

    }
})();

